export default __webpack_public_path__ + "static/media/quiz_bg.209401b3.png";